const plugins1 = `
&lt;span class="counter">7741&lt;/span>

$('.counter').countUp({ delay: 10, time: 1000, duration: 3 });
 `
const plugins2 = `
&lt;script src="/static/js/jquery.js">&lt;/script>
&lt;script src="/static/js/jquery.countup.min.js">&lt;/script>
&lt;script src="/static/js/jquery.waypoints.min.js">&lt;/script>
 `
const plugins3 = `
&lt;p class="animated fadeInUp wow">Animate.css&lt;/p>

&lt;link rel="stylesheet" href="/static/css/animate.min.css" >
&lt;script src="/static/js/wow.js">&lt;/script>

new WOW().init();
 `
const plugins4 = `
&lt;div class="swiper-container">
    &lt;div class="swiper-wrapper">
        &lt;div class="swiper-slide">1&lt;/div>
        &lt;div class="swiper-slide">2&lt;/div>
        &lt;div class="swiper-slide">3&lt;/div>
    &lt;/div>
&lt;/div>

new Swiper(".swiper-container")
 `

export default {
    plugins1,
    plugins2,
    plugins3,
    plugins4
}